import { createContext, ReactNode } from "react";
import { AuthController } from "src/contexts/auth/application/AuthController";
import { DocumentationAreaController } from "src/contexts/documentationArea/application/DocumentationAreaController";
import { TranslationController } from "src/contexts/translation/application/TranslationController";

export type AppDependencies = {
  documentationAreaController: DocumentationAreaController;
  translationController: TranslationController;
  authController: AuthController;
};

export const AppDependenciesContext = createContext<AppDependencies>({} as AppDependencies);

export const AppDependenciesProvider = ({
  children,
  ...dependencies
}: AppDependencies & { children: ReactNode }) => {
  return (
    <AppDependenciesContext.Provider value={dependencies}>
      {children}
    </AppDependenciesContext.Provider>
  );
};
